(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snuwi-reviews-cepillo"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initRoot(root){
    if(!root || root.dataset.snuwiReady === '1') return;
    root.dataset.snuwiReady = '1';

    var scope = root.closest('[id^="shopify-section-"]') || root.parentElement || document;
    var cards = Array.prototype.slice.call(root.querySelectorAll('.sr-review-card'));
    var more = root.querySelector('#srAliMore');
    var sort = root.querySelector('#srAliSort');
    var status = root.querySelector('#srAliStatus');

    if(!cards.length || !more || !sort || !status) return;

    var current = 'all';
    var shown = 10;

    function matches(card){
      var rating = parseInt(card.dataset.rating || '5', 10);
      if(current === 'photos') return card.dataset.hasPhotos === '1';
      if(current === '5') return rating === 5;
      return true;
    }

    function ordered(){
      var arr = cards.filter(matches);

      if(sort.value === 'high'){
        arr.sort(function(a,b){
          return Number(b.dataset.rating) - Number(a.dataset.rating);
        });
      }

      if(sort.value === 'low'){
        arr.sort(function(a,b){
          return Number(a.dataset.rating) - Number(b.dataset.rating);
        });
      }

      if(sort.value === 'photos'){
        arr.sort(function(a,b){
          return Number(b.dataset.hasPhotos) - Number(a.dataset.hasPhotos);
        });
      }

      return arr;
    }

    function render(){
      var arr = ordered();

      cards.forEach(function(card){
        card.hidden = true;
        card.style.display = 'none';
      });

      arr.slice(0, shown).forEach(function(card){
        card.hidden = false;
        card.style.display = '';
      });

      var visible = Math.min(shown, arr.length);

      status.textContent = arr.length
        ? 'Mostrando ' + visible + ' de ' + arr.length + ' reseñas'
        : 'No hay reseñas para este filtro.';

      if(shown >= arr.length){
        more.hidden = true;
        more.style.display = 'none';
      }else{
        more.hidden = false;
        more.style.display = '';
        more.textContent = 'Mostrar más reseñas (' + visible + ' de ' + arr.length + ')';
      }
    }

    root.querySelectorAll('.sr-filter').forEach(function(btn){
      btn.addEventListener('click', function(){
        root.querySelectorAll('.sr-filter').forEach(function(other){
          other.classList.remove('active');
        });

        btn.classList.add('active');
        current = btn.dataset.filter || 'all';
        shown = 10;
        render();
      });
    });

    sort.addEventListener('change', function(){
      shown = 10;
      render();
    });

    more.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();

      shown = Math.min(shown + 10, ordered().length);
      render();

      requestAnimationFrame(function(){
        more.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      });
    });

    render();
  }

  function initAll(){
    document.querySelectorAll('#snuwi-alix-reviews').forEach(initRoot);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll, { once:true });
  }else{
    initAll();
  }

  document.addEventListener('shopify:section:load', function(event){
    event.target
      .querySelectorAll('#snuwi-alix-reviews')
      .forEach(function(root){
        root.dataset.snuwiReady = '0';
        initRoot(root);
      });
  });
  /* =========================================================
     LIGHTBOX GLOBAL ROBUSTO
     No depende del lifecycle del editor de Shopify.
     Se activa por delegación al hacer clic en cualquier foto.
  ========================================================== */
  (function installGlobalLightbox(){
    if(window.__snuwiLightboxInstalled) return;
    window.__snuwiLightboxInstalled = true;

    var overlay = null;
    var image = null;
    var counter = null;
    var prev = null;
    var next = null;
    var close = null;
    var activeImages = [];
    var activeIndex = 0;

    function ensureLightbox(){
      if(overlay && document.body.contains(overlay)) return;

      overlay = document.createElement('div');
      overlay.className = 'sr-lightbox sr-lightbox-global';
      overlay.setAttribute('aria-hidden','true');

      overlay.innerHTML =
        '<button type="button" class="sr-lb-close" aria-label="Cerrar">×</button>' +
        '<button type="button" class="sr-lb-prev" aria-label="Anterior">‹</button>' +
        '<img class="sr-lb-image" alt="Imagen ampliada" width="1200" height="1200">' +
        '<button type="button" class="sr-lb-next" aria-label="Siguiente">›</button>' +
        '<div class="sr-lb-count"></div>';

      document.body.appendChild(overlay);

      image = overlay.querySelector('.sr-lb-image');
      counter = overlay.querySelector('.sr-lb-count');
      prev = overlay.querySelector('.sr-lb-prev');
      next = overlay.querySelector('.sr-lb-next');
      close = overlay.querySelector('.sr-lb-close');

      close.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        closeLightbox();
      });

      prev.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        if(!activeImages.length) return;
        activeIndex = (activeIndex - 1 + activeImages.length) % activeImages.length;
        updateLightbox();
      });

      next.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        if(!activeImages.length) return;
        activeIndex = (activeIndex + 1) % activeImages.length;
        updateLightbox();
      });

      overlay.addEventListener('click', function(e){
        if(e.target === overlay) closeLightbox();
      });
    }

    function getImageUrl(button){
      var img = button.querySelector('img');
      if(!img) return '';
      return img.currentSrc || img.getAttribute('src') || img.src || '';
    }

    function collectGroup(clicked){
      var root = clicked.closest('#snuwi-alix-reviews');
      if(!root) return [];

      var group = clicked.getAttribute('data-lightbox-group');
      if(!group) return [getImageUrl(clicked)].filter(Boolean);

      return Array.prototype.slice.call(
        root.querySelectorAll('[data-lightbox-group="' + group + '"]')
      ).map(getImageUrl).filter(Boolean);
    }

    function updateLightbox(){
      if(!activeImages.length || !image) return;

      image.removeAttribute('src');
      image.src = activeImages[activeIndex];

      if(counter){
        counter.textContent = (activeIndex + 1) + ' / ' + activeImages.length;
      }

      if(prev) prev.style.display = activeImages.length > 1 ? '' : 'none';
      if(next) next.style.display = activeImages.length > 1 ? '' : 'none';
    }

    function openLightbox(clicked){
      ensureLightbox();

      activeImages = collectGroup(clicked);
      if(!activeImages.length) return;

      var clickedUrl = getImageUrl(clicked);
      activeIndex = Math.max(0, activeImages.indexOf(clickedUrl));

      updateLightbox();

      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden','false');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox(){
      if(!overlay) return;

      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden','true');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function(e){
      var clicked = e.target.closest(
        '#snuwi-alix-reviews .sr-gallery-item, #snuwi-alix-reviews .sr-review-photo'
      );

      if(!clicked) return;

      e.preventDefault();
      e.stopPropagation();

      openLightbox(clicked);
    }, true);

    document.addEventListener('keydown', function(e){
      if(!overlay || !overlay.classList.contains('open')) return;

      if(e.key === 'Escape'){
        closeLightbox();
      }else if(e.key === 'ArrowLeft' && prev){
        prev.click();
      }else if(e.key === 'ArrowRight' && next){
        next.click();
      }
    });
  })();

})();

  } catch(e) { console.error(e); }
})();
})();
